const COLORS_PAYMENT: { [key: number]: string } = {
    1: '#FF8A00',
    2: '#456AEF',
    3: '#3AB956',
    4: '#E74A4A',
};

export default COLORS_PAYMENT;
